import * as React from 'react';
import {useNavigate} from 'react-router-dom';

import HandleRoutes from '../../routes/HandleRouters';
import useAuth from '../../hooks/useAuth';
import {path} from '../../routes/path';
import {RbacPermissionString} from '../../types/typeRoleBasedAccessControls';

interface AuthGuardType {
  children: {
    node: React.ReactNode;
    requiredPermissions: RbacPermissionString[];
  };
}

// For routes that can only be accessed by authenticated users
function AuthRbacGuard({children}: AuthGuardType) {
  const {node, requiredPermissions} = children;
  const {isAuthenticated, isInitialized, checkRbac} = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (
      isInitialized &&
      (!isAuthenticated || !checkRbac({permissionString: requiredPermissions}))
    ) {
      if (!isAuthenticated) {
        navigate(`/${path.AUTH}/${path.SIGN_IN}`);
      } else if (!checkRbac({permissionString: requiredPermissions})) {
        navigate(`/${path.NO_ACCESS}`);
      }
    }
  }, [isInitialized, isAuthenticated, requiredPermissions, navigate]);

  // If user is not authenticated or does not have required permissions, redirect to sign-in page
  if (
    isInitialized &&
    (!isAuthenticated || !checkRbac({permissionString: requiredPermissions}))
  ) {
    return null;
  }

  return (
    <React.Fragment>
      <HandleRoutes content={node} />
    </React.Fragment>
  );
}

export default AuthRbacGuard;
